import React from 'react';
import css from './MapPanControl.module.css';

/**
 * Custom pan control for Mapbox map
 * Allows users to pan the map in 4 directions (up, down, left, right)
 */
class MapPanControl extends React.Component {
  constructor(props) {
    super(props);
    this.panDistance = 100; // pixels to pan
  }

  handlePan = direction => {
    const { map } = this.props;
    if (!map) return;

    const panAmount = this.panDistance;

    switch (direction) {
      case 'up':
        map.panBy([0, -panAmount], { duration: 300 });
        break;
      case 'down':
        map.panBy([0, panAmount], { duration: 300 });
        break;
      case 'left':
        map.panBy([-panAmount, 0], { duration: 300 });
        break;
      case 'right':
        map.panBy([panAmount, 0], { duration: 300 });
        break;
      default:
        break;
    }
  };

  render() {
    return (
      <div className={css.panControl}>
        <button
          className={css.panButton}
          onClick={() => this.handlePan('up')}
          aria-label="Pan up"
          type="button"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
  <path d="M7.49113 0.213263L0.189881 7.87614C0.0679947 8.004 0 8.17387 0 8.35051C0 8.52716 0.0679947 8.69703 0.189881 8.82489L0.198131 8.83314C0.257219 8.89534 0.328343 8.94486 0.407176 8.97871C0.486009 9.01255 0.570903 9.03 0.656694 9.03C0.742484 9.03 0.827378 9.01255 0.906211 8.97871C0.985044 8.94486 1.05617 8.89534 1.11526 8.83314L7.99026 1.61714L14.8625 8.83314C14.9216 8.89534 14.9927 8.94486 15.0716 8.97871C15.1504 9.01255 15.2353 9.03 15.3211 9.03C15.4069 9.03 15.4918 9.01255 15.5706 8.97871C15.6494 8.94486 15.7205 8.89534 15.7796 8.83314L15.7879 8.82489C15.9098 8.69703 15.9778 8.52716 15.9778 8.35051C15.9778 8.17387 15.9098 8.004 15.7879 7.87614L8.48663 0.213263C8.42242 0.145871 8.3452 0.0922197 8.25964 0.0555612C8.17408 0.0189026 8.08196 0 7.98888 0C7.8958 0 7.80369 0.0189026 7.71813 0.0555612C7.63257 0.0922197 7.55534 0.145871 7.49113 0.213263Z" fill="black"/>
</svg>
        </button>

        <div className={css.panMiddleRow}>
          <button
            className={css.panButton}
            onClick={() => this.handlePan('left')}
            aria-label="Pan left"
            type="button"
          >
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
  <path d="M0.209246 8.36324L7.76085 15.6068C7.88686 15.7277 8.05457 15.7955 8.22921 15.7961C8.40385 15.7967 8.57201 15.73 8.69882 15.61L8.707 15.6018C8.76869 15.5436 8.81789 15.4735 8.85161 15.3956C8.88533 15.3178 8.90286 15.2339 8.90314 15.1491C8.90343 15.0643 8.88645 14.9803 8.85326 14.9023C8.82006 14.8242 8.77133 14.7538 8.71003 14.6951L1.59881 7.87443L8.7555 1.10418C8.81719 1.04597 8.86639 0.975813 8.90011 0.897988C8.93382 0.820164 8.95136 0.736293 8.95164 0.651478C8.95193 0.566663 8.93495 0.482676 8.90176 0.404628C8.86856 0.326579 8.81983 0.2561 8.75853 0.197478L8.7504 0.189294C8.6244 0.06837 8.45669 0.000585949 8.28205 1.72787e-06C8.10741 -0.000582493 7.93925 0.0660779 7.81244 0.186156L0.212539 7.37905C0.145701 7.44231 0.092404 7.51848 0.0558792 7.60295C0.0193545 7.68741 0.000362108 7.77842 5.42586e-05 7.87044C-0.000253593 7.96246 0.0181295 8.05359 0.0540883 8.1383C0.0900471 8.22301 0.142833 8.29953 0.209246 8.36324Z" fill="black"/>
</svg>
          </button>

          <div className={css.panCenter}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"></svg>
          </div>

          <button
            className={css.panButton}
            onClick={() => this.handlePan('right')}
            aria-label="Pan right"
            type="button"
          >
       <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
  <path d="M8.7294 7.39082L1.14 0.186848C1.01337 0.0665853 0.845303 -0.000319782 0.670663 9.66283e-06C0.496024 0.000339108 0.328213 0.0678778 0.202035 0.188617L0.193893 0.196789C0.132512 0.255322 0.0836808 0.32573 0.0503682 0.40373C0.0170566 0.48173 -3.98754e-05 0.565691 0.000120123 0.650507C0.000280122 0.735323 0.0176932 0.819219 0.0512989 0.897093C0.0849055 0.974967 0.134002 1.04519 0.195604 1.10349L7.34241 7.8869L0.221242 14.6945C0.159861 14.753 0.11103 14.8234 0.0777171 14.9014C0.0444055 14.9794 0.027309 15.0634 0.027469 15.1482C0.027629 15.233 0.0450422 15.3169 0.0786478 15.3948C0.112254 15.4727 0.161351 15.5429 0.222953 15.6012L0.231125 15.6093C0.357758 15.7296 0.525822 15.7965 0.700462 15.7962C0.875101 15.7958 1.04291 15.7283 1.16909 15.6076L8.73126 8.37501C8.79776 8.31141 8.85066 8.23496 8.88674 8.1503C8.92283 8.06565 8.94134 7.97455 8.94117 7.88252C8.941 7.7905 8.92214 7.69946 8.88573 7.61494C8.84933 7.53043 8.79615 7.45418 8.7294 7.39082Z" fill="black"/>
</svg>
          </button>
        </div>

        <button
          className={css.panButton}
          onClick={() => this.handlePan('down')}
          aria-label="Pan down"
          type="button"
        >
       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9" fill="none">
  <path d="M8.34789 8.75695L15.6057 1.21902C15.7269 1.09325 15.795 0.92566 15.7959 0.751023C15.7968 0.576386 15.7304 0.408098 15.6106 0.281064L15.6025 0.272864C15.5444 0.211068 15.4743 0.161737 15.3966 0.12787C15.3188 0.0940039 15.235 0.0763102 15.1502 0.0758665C15.0654 0.0754227 14.9813 0.0922382 14.9032 0.125289C14.8251 0.15834 14.7545 0.206935 14.6958 0.268121L7.8617 7.36646L1.10496 0.197016C1.04687 0.13522 0.976807 0.085889 0.899046 0.052022C0.821285 0.018156 0.737447 0.000462359 0.652634 1.86315e-05C0.567819 -0.0004251 0.483801 0.0163904 0.40569 0.0494409C0.327578 0.0824924 0.257008 0.131087 0.19827 0.192273L0.19007 0.200387C0.0689091 0.32616 0.000808824 0.493745 -0.000104839 0.668382C-0.0010185 0.843019 0.0653246 1.01131 0.185163 1.13834L7.36371 8.7518C7.42684 8.81876 7.50291 8.8722 7.58731 8.90888C7.6717 8.94556 7.76267 8.96473 7.8547 8.96521C7.94672 8.96569 8.03788 8.94748 8.12266 8.91168C8.20744 8.87588 8.28406 8.82324 8.34789 8.75695Z" fill="black"/>
</svg>
        </button>
      </div>
    );
  }
}

export default MapPanControl;
